import { SourcingEventStatus } from "../../../autogen/bff-api";

export type BucketKey =
  | "arbeid"
  | "kunngjort"
  | "evaluering"
  | "tildeling"
  | "fullfort";

export type BucketBadgeKey =
  | "anskArbeid"
  | "anskKunngjort"
  | "anskEvaluering"
  | "anskTildeling"
  | "anskFullfort";

export const STATUS_BUCKET: Record<SourcingEventStatus, BucketKey> = {
  [SourcingEventStatus.Draft]: "arbeid",
  [SourcingEventStatus.PublicationPending]: "arbeid",
  [SourcingEventStatus.PublicationFailed]: "arbeid",
  [SourcingEventStatus.Published]: "kunngjort",
  [SourcingEventStatus.Evaluation]: "evaluering",
  [SourcingEventStatus.AwardDecision]: "tildeling",
  [SourcingEventStatus.Awarded]: "tildeling",
  [SourcingEventStatus.Closed]: "fullfort",
  [SourcingEventStatus.Cancelled]: "fullfort",
  [SourcingEventStatus.Completed]: "fullfort",
};

export const BUCKET_META: Record<BucketKey, { labelKey: string; badgeKey: BucketBadgeKey }> = {
  arbeid: { labelKey: "In progress", badgeKey: "anskArbeid" },
  kunngjort: { labelKey: "Announced", badgeKey: "anskKunngjort" },
  evaluering: { labelKey: "Under evaluation", badgeKey: "anskEvaluering" },
  tildeling: { labelKey: "Award and standstill", badgeKey: "anskTildeling" },
  fullfort: { labelKey: "Completed", badgeKey: "anskFullfort" },
};

export const STATUSES_BY_BUCKET: Record<BucketKey, SourcingEventStatus[]> = (
  Object.entries(STATUS_BUCKET) as [SourcingEventStatus, BucketKey][]
).reduce(
  (acc, [status, bucket]) => {
    acc[bucket].push(status);
    return acc;
  },
  Object.fromEntries(
    (Object.keys(BUCKET_META) as BucketKey[]).map((bucket) => [bucket, [] as SourcingEventStatus[]]),
  ) as Record<BucketKey, SourcingEventStatus[]>,
);

export const countBadgesByStatus = (
  events: { status: SourcingEventStatus }[],
): Partial<Record<BucketBadgeKey, number>> => {
  const badges: Partial<Record<BucketBadgeKey, number>> = {};
  for (const event of events) {
    // The BFF may send statuses newer than this build's enum; skip them.
    const badgeKey = BUCKET_META[STATUS_BUCKET[event.status]]?.badgeKey;
    if (!badgeKey) continue;
    badges[badgeKey] = (badges[badgeKey] ?? 0) + 1;
  }
  return badges;
};

export const bucketQuery = (bucket: BucketKey): string => `status=${bucket}`;

export const isBucketKey = (slug: string | null): slug is BucketKey =>
  slug != null && Object.prototype.hasOwnProperty.call(BUCKET_META, slug);
